function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1 92.68c19.754 1.66 66.65-.797 96.195-23.903 36.932-28.884 63.557-35.357 91.9-28.884 28.343 6.474 43.803 8.466 72.146 28.884 28.343 20.417 59.263 16.433 122.82 15.437 50.846-.797 80.162-.332 88.465 0 15.459-1.494 54.109-.1 85.029 17.43 38.649 21.911 91.9 46.312 134.844 0 42.944-46.313 57.545-86.152 120.243-70.216 62.699 15.935 57.545 27.389 109.078 28.385 41.227.797 130.55.332 170.06 0 16.32-.332 52.56-4.78 66.99-19.92 18.04-18.923 52.39-42.826 89.32-38.345 36.94 4.482 37.8 14.442 67.86 13.446 24.05-.797 74.72-.332 97.05 0",
  stroke: "#C4C4C4",
  strokeWidth: 2
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M97.195 70.036C67.649 93.23 20.755 95.697 1 94.03V186h1412V16.048c-22.33-.334-73-.8-97.05 0-30.06 1-30.92-8.998-67.86-13.497-36.93-4.5-71.28 19.495-89.32 38.491-14.43 15.197-50.67 19.663-66.99 19.996-39.51.333-128.834.8-170.06 0-51.533-1-46.379-12.497-109.078-28.494-62.698-15.996-77.299 23.995-120.243 70.485-42.944 46.49-96.195 21.995-134.844 0-30.92-17.596-69.57-18.996-85.029-17.496-8.303-.334-37.619-.8-88.465 0-63.557 1-94.477 4.998-122.82-15.497-28.343-20.496-43.803-22.495-72.146-28.994-28.343-6.498-54.968 0-91.9 28.994z",
  fill: "url(#graph-skeleton_svg__paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "graph-skeleton_svg__paint0_linear",
  x1: 707,
  y1: 28.5,
  x2: 707,
  y2: 236,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ECECEC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})));

function SvgGraphSkeleton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1414,
    height: 196,
    viewBox: "0 0 1414 186",
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default SvgGraphSkeleton;